import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-097705de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register-form__information" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "register-form__title" }, "Cadastre-se"),
  /*#__PURE__*/_createElementVNode("p", { class: "register-form__description" }, " Preencha os campos abaixo para realizar o seu cadastro. ")
], -1))
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "pair" }
const _hoisted_5 = {
  key: 0,
  class: "pair"
}
const _hoisted_6 = {
  key: 1,
  class: "pair"
}
const _hoisted_7 = {
  key: 2,
  class: "pair"
}
const _hoisted_8 = {
  key: 3,
  class: "pair"
}
const _hoisted_9 = { class: "pair" }
const _hoisted_10 = { class: "container-password" }
const _hoisted_11 = { class: "pair pair--terms" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  required: "",
  id: "terms",
  type: "checkbox",
  class: "input__terms"
}, null, -1))
const _hoisted_13 = {
  class: "label__terms",
  for: "terms"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Aceito os ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Termos de Uso e Política de Privacidade")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "register-form__button",
  type: "submit"
}, "Cadastrar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modern_input = _resolveComponent("modern-input")!
  const _component_input_password = _resolveComponent("input-password")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "register-modal",
      onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn--exit",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleRegisterModal')))
        }),
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
          id: "register-form",
          class: "register-form"
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_modern_input, {
                form: "register-form",
                required: "",
                class: "modern-input",
                id: "register-name",
                label: "Nome",
                type: "text",
                userData: _ctx.user.name,
                "onUpdate:userData": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.name) = $event))
              }, null, 8, ["userData"]),
              _createVNode(_component_modern_input, {
                max: _ctx.maxDate,
                min: "1900-01-01",
                form: "register-form",
                required: "",
                class: "modern-input",
                id: "register-birthDate",
                label: "Data de nascimento",
                type: "date",
                userData: _ctx.user.birthDate,
                "onUpdate:userData": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.birthDate) = $event))
              }, null, 8, ["max", "userData"])
            ]),
            _createVNode(_component_modern_input, {
              form: "register-form",
              required: "",
              class: "modern-input",
              id: "register-document",
              label: "CPF",
              type: "text",
              userData: _ctx.user.document,
              "onUpdate:userData": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.document) = $event)),
              "has-mask": "",
              "input-mask": "###.###.###-##"
            }, null, 8, ["userData"]),
            _createVNode(_component_modern_input, {
              form: "register-form",
              required: "",
              class: "modern-input",
              id: "register-email",
              label: "E-mail",
              type: "email",
              userData: _ctx.user.email,
              "onUpdate:userData": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event))
            }, null, 8, ["userData"]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_modern_input, {
                    "max-length": "14",
                    form: "register-form",
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.requestCepAPI($event.target.value))),
                    class: "modern-input",
                    id: "register-CEP",
                    label: "CEP",
                    type: "text",
                    userData: _ctx.user.address.zipCode,
                    "onUpdate:userData": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.address.zipCode) = $event)),
                    "has-mask": "",
                    "input-mask": "#####-###"
                  }, null, 8, ["userData"])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    userData: _ctx.user.address.stateID,
                    "onUpdate:userData": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.address.stateID) = $event)),
                    class: "modern-input",
                    id: "register-uf",
                    label: "UF (Estado)",
                    type: "select",
                    options: _ctx.states
                  }, null, 8, ["userData", "options"]),
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    userData: _ctx.user.address.city,
                    "onUpdate:userData": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.address.city) = $event)),
                    class: "modern-input",
                    id: "register-city",
                    label: "Cidade",
                    type: "text"
                  }, null, 8, ["userData"])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    "user-data": _ctx.user.address.street,
                    "onUpdate:user-data": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.address.street) = $event)),
                    class: "modern-input",
                    id: "register-street",
                    label: "Rua",
                    type: "text"
                  }, null, 8, ["user-data"]),
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    "user-data": _ctx.user.address.district,
                    "onUpdate:user-data": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.address.district) = $event)),
                    class: "modern-input",
                    id: "register-neighborhood",
                    label: "Bairro",
                    type: "text"
                  }, null, 8, ["user-data"])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    "user-data": _ctx.user.address.addressNumber,
                    "onUpdate:user-data": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.address.addressNumber) = $event)),
                    min: "0",
                    class: "modern-input",
                    id: "register-number",
                    label: "Número",
                    type: "number"
                  }, null, 8, ["user-data"]),
                  _createVNode(_component_modern_input, {
                    form: "register-form",
                    "user-data": _ctx.user.address.complement,
                    "onUpdate:user-data": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.address.complement) = $event)),
                    class: "modern-input",
                    id: "register-complement",
                    label: "Complemento",
                    type: "text"
                  }, null, 8, ["user-data"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_input_password, {
                form: "register-form",
                required: "",
                "model-value": _ctx.user.password,
                "onUpdate:model-value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.password) = $event)),
                id: "register-password",
                label: "Senha",
                passwordVisibility: true
              }, null, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_modern_input, {
                  form: "register-form",
                  required: "",
                  "user-data": _ctx.user.passwordConfirmation,
                  "onUpdate:user-data": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.passwordConfirmation) = $event)),
                  id: "register-passwordConfirmation",
                  label: "Confirme sua senha",
                  type: _ctx.isPasswordVisible ? 'text' : 'password'
                }, null, 8, ["user-data", "type"]),
                _createElementVNode("span", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.togglePassword())),
                  class: _normalizeClass(["input__visibility", _ctx.isPasswordVisible ? '' : 'notVisible'])
                }, null, 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("label", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_router_link, {
                to: { name: 'terms' },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_16
        ], 32)
      ])
    ])
  ]))
}